/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const log = require('@gral/log')('ACT: DISPATCHER');
const dispatcher = require('../dispatcher/dispatcher');

const _doDispatch = action => dispatcher.dispatch(action);
module.exports = {
  relay(action) {
    if (dispatcher.isDispatching()) {
      log.debug(`Deferring #${action.seq} ${action.type} (dispatcher is busy)`);
      setTimeout(() => _doDispatch(action), 0);
      return;
    }
    return _doDispatch(action);
  },
};
